import { render, staticRenderFns } from "./SignUpPage.vue?vue&type=template&id=401bf204&scoped=true"
import script from "./SignUpPage.vue?vue&type=script&lang=ts"
export * from "./SignUpPage.vue?vue&type=script&lang=ts"
import style0 from "./SignUpPage.vue?vue&type=style&index=0&id=401bf204&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401bf204",
  null
  
)

export default component.exports